export default __webpack_public_path__ + "static/media/health_link.1077d848.jpg";